import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, ToggleButton } from '@mui/material';

import RouteIcon from '@mui/icons-material/Route';

import style from '../../DeliveryGeoMapEditorWidget.module.css';

export default function MapToolbar({ showTrackModeTrigger, isFullscreen, trackMode, switchMode }) {
  return showTrackModeTrigger ? (
    <Tooltip
      title="Показывать треки"
      placement="top"
      sx={{
        alignSelf: 'flex-end',
        position: isFullscreen ? { xs: 'static', sm: 'absolute' } : 'static',
      }}
    >
      <ToggleButton
        disableRipple
        size="small"
        selected={trackMode}
        value=""
        onChange={switchMode}
        className={isFullscreen ? style.trackToggler : null}
      >
        <RouteIcon color="primary" />
      </ToggleButton>
    </Tooltip>
  ) : null;
}
MapToolbar.propTypes = {
  showTrackModeTrigger: PropTypes.bool.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
  trackMode: PropTypes.bool.isRequired,
  switchMode: PropTypes.func.isRequired,
};
